const matchBaseAndIndexSuffix = /(.+)\.index$/;

export default function routesMatch(a, b) {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  const ab = a.replace(matchBaseAndIndexSuffix, '$1');
  if (ab === b) {
    return true;
  }
  const bb = b.replace(matchBaseAndIndexSuffix, '$1');
  return a === bb || ab === bb;
}
